<template>
  <div class="fullscreen-layout">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'FullscreenLayout',
  };
</script>

<style scoped lang="scss">
  .fullscreen-layout {
    position: fixed;
    top: var(--app-alert-offset, 0px);
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
</style>
